import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { PqrTypeActionsProps } from './props';
import { usePqrTypeListActions } from './hook';

export const PqrTypeListActions = ({ id }: PqrTypeActionsProps) => {
    const { handleEdit } = usePqrTypeListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
